import { cn } from '@up2stay/up2promo-ui';
import { Pencil } from 'lucide-react';

/**
 * Always-visible edit cue for lead-detail inline fields.
 * Decorative only (`aria-hidden`); pointer-events none so taps hit the control.
 */
export function LeadDetailEditHint({ className }: { className?: string }) {
  return (
    <Pencil
      aria-hidden
      className={cn(
        'pointer-events-none size-3.5 shrink-0 text-muted-foreground/50',
        className,
      )}
    />
  );
}
